import seo from "../../assets/home/seo.png";
import technologies from "../../assets/services/TECHNOLOGY.png";
import snewai from "../../assets/services/AI.png";
import consumables from "../../assets/services/CONSUMABLES.png";
import electronics from "../../assets/services/ELECTRONICS.png";
import event from "../../assets/services/EVENTS.png";
import logistics from "../../assets/services/LOGISTICS.png";
import media from "../../assets/services/MEDIA.png";
import snewspace from "../../assets/services/SNEWSPACE.png";

const data = [
  {
    id: 1,
    heading: "TECHNOLOGIES",
    content:
      "Strategic partner delivering digital solutions for brands to lead.",
    to: "/",
    icon: technologies,
  },
  {
    id: 2,
    heading: "SNEW AI",
    content:
      "Transformative AI and Robotics solutions redefining business innovation.",
    to: "/",
    icon: snewai,
  },
  {
    id: 3,
    heading: "EVENTS",
    content:
      "Exceptional events blending creativity, precision, and seamless coordination.",
    to: "/",
    icon: event,
  },
  {
    id: 4,
    heading: "MEDIA",
    content:
      "Transforming ideas into visual experiences with storytelling, technology, and precision.",
    to: "/",
    icon: media,
  },
  {
    id: 5,
    heading: "LOGISTICS",
    content:
      "Simplifying global trade with reliable logistics connecting businesses across borders.",
    to: "/",
    icon: logistics,
  },
  {
    id: 6,
    heading: "CONSUMABLES",
    content:
      "Delivering high-quality food products and consumables for modern, healthy living.",
    to: "/",
    icon: consumables,
  },
  {
    id: 7,
    heading: "ELECTRONICS",
    content:
      "Empowering creators with advanced audio-visual equipment and reliable computing solutions.",
    to: "/",
    icon: electronics,
  },
  {
    id: 8,
    heading: "SNEW SPACE",
    content:
      "Integrated solutions for design, construction, and sourcing under one roof.",
    to: "/",
    icon: snewspace,
  },
];

export default data;
